import React, { Component } from "react";

class SalaVR extends Component {
  componentDidMount() {
  if (window.startx) {
    window.startx();
  }
}


  state = {
    activeImage: {},
    previewFolder: null,
    previewIndex: 1,
    touchStartX: 0
  };

  simuladores = [
    { nombre: "AR Racing", descripcion: "Experiencia de carreras en Realidad Aumentada.", carpeta: "arracing" },
    { nombre: "Cybertruck VR", descripcion: "Maneja el futuro con Cybertruck.", carpeta: "cybertruck" },
    { nombre: "Huevo VR", descripcion: "Experiencia inmersiva de 360 grados.", carpeta: "huevovr" },
    { nombre: "Hypermoto VR", descripcion: "Simulador de motocicletas en Realidad Virtual.", carpeta: "hypermoto" },
    { nombre: "VR Slide", descripcion: "Deslizate en Realidad Virtual.", carpeta: "vrslide" }
  ];

  setImage = (folder, index) => {
    this.setState({
      activeImage: { ...this.state.activeImage, [folder]: index }
    });
  };

  openPreview = (folder, index) => {
    this.setState({
      previewFolder: folder,
      previewIndex: index
    });
  };

  closePreview = () => {
    this.setState({ previewFolder: null });
  };

  nextImage = () => {
    this.setState({
      previewIndex: this.state.previewIndex === 3 ? 1 : this.state.previewIndex + 1
    });
  };

  prevImage = () => {
    this.setState({
      previewIndex: this.state.previewIndex === 1 ? 3 : this.state.previewIndex - 1
    });
  };

  handleTouchStart = (e) => {
    this.setState({ touchStartX: e.touches[0].clientX });
  };

  handleTouchEnd = (e) => {
    const delta = e.changedTouches[0].clientX - this.state.touchStartX;
    if (delta > 50) this.prevImage();
    if (delta < -50) this.nextImage();
  };

  render() {
    const { previewFolder, previewIndex } = this.state;

    return (
      <div className="container mt-5 mb-5 pt-5">

        <header className="major">
          <h2>Sala de Realidad Virtual</h2>
          <p>Vive experiencias inmersivas con nuestras atracciones de última generación.</p>
        </header>

        <div className="row gtr-50">
          {this.simuladores.map((sim) => {
            const active = this.state.activeImage[sim.carpeta] || 1;

            return (
              <div className="col-12 col-md-6" key={sim.carpeta}>
                <div className="box">
                  <h3>{sim.nombre}</h3>
                  <p>{sim.descripcion}</p>

                  <img
                    src={`/images/vr/${sim.carpeta}/${active}.jpg`}
                    alt={sim.nombre}
                    onClick={() => this.openPreview(sim.carpeta, active)}
                    style={{
                      width: "100%",
                      height: "260px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      cursor: "zoom-in",
                      marginBottom: "10px"
                    }}
                  />

                  <div style={{ display: "flex", gap: "6px" }}>
                    {[1, 2, 3].map((n) => (
                      <img
                        key={n}
                        src={`/images/vr/${sim.carpeta}/${n}.jpg`}
                        alt=""
                        onMouseEnter={() => this.setImage(sim.carpeta, n)}
                        onClick={() => this.openPreview(sim.carpeta, n)}
                        style={{
                          width: "18%",
                          height: "48px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          cursor: "pointer",
                          opacity: active === n ? 1 : 0.6
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* OVERLAY */}
        {previewFolder && (
          <div
            onClick={this.closePreview}
            style={overlay}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              onTouchStart={this.handleTouchStart}
              onTouchEnd={this.handleTouchEnd}
              style={{ position: "relative" }}
            >
              <img
                src={`/images/vr/${previewFolder}/${previewIndex}.jpg`}
                alt="Vista ampliada"
                style={previewImg}
              />

              {/* Flechas */}
              <button onClick={this.prevImage} style={navBtn("left")}>‹</button>
              <button onClick={this.nextImage} style={navBtn("right")}>›</button>

              {/* Indicadores */}
              <div style={dotsContainer}>
                {[1, 2, 3].map((n) => (
                  <span
                    key={n}
                    onClick={() => this.setState({ previewIndex: n })}
                    style={{
                      ...dot,
                      opacity: previewIndex === n ? 1 : 0.4
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.7)",
  zIndex: 10000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const previewImg = {
  maxWidth: "90vw",
  maxHeight: "80vh",
  borderRadius: "14px"
};

const navBtn = (side) => ({
  position: "absolute",
  top: "50%",
  [side]: "-45px",
  transform: "translateY(-50%)",
  fontSize: "2.5rem",
  background: "none",
  color: "#fff",
  border: "none",
  cursor: "pointer"
});

const dotsContainer = {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  marginTop: "14px"
};

const dot = {
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  background: "#fff",
  cursor: "pointer"
};

export default SalaVR;
